import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility for wrapping clsx and tailwind-merge together.
 */
function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export { cn };
//# sourceMappingURL=utils.js.map
